import { render, staticRenderFns } from "./AlbumGallery.vue?vue&type=template&id=0e9406a8&scoped=true&"
import script from "./AlbumGallery.vue?vue&type=script&lang=js&"
export * from "./AlbumGallery.vue?vue&type=script&lang=js&"
import style0 from "./AlbumGallery.vue?vue&type=style&index=0&id=0e9406a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9406a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9406a8')) {
      api.createRecord('0e9406a8', component.options)
    } else {
      api.reload('0e9406a8', component.options)
    }
    module.hot.accept("./AlbumGallery.vue?vue&type=template&id=0e9406a8&scoped=true&", function () {
      api.rerender('0e9406a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/publicAlbum/AlbumGallery.vue"
export default component.exports